import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
/**
 * 記事一覧ページ用の見出しコンポーネント
 *
 * @param props
 * @constructor
 */
export const ArticleListHead = (props) => {
    const { category, className = '', title } = props;
    return (_jsx(Head, Object.assign({ className: clsx('lg:text-head-xl', className), color: 'primary', size: 'md' }, { children: category ? (_jsxs(_Fragment, { children: [`「${category}」`, _jsx("span", Object.assign({ className: 'text-16 ml-4' }, { children: `の${title}` }))] })) : (title) })));
};
